import _ from "lodash";

import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";
import type { NormalizedCustomerDto } from "helpers/normalizeCustomerDto";
import type { TicketEmailAutoResponseDecisionDto } from "@src/api-new/generated-api.schemas";

import type { ActiveRouteType } from "../../utils/routeMatcher";
import ENV from "../../constants/ENV";


interface AppState {
  initInProgress: boolean;
  modalState: {
    [modalId: number | string]: string;
  };
  isMobileMenuVisible: boolean;
  customerStatus?: string;
  hasActiveLoan?: boolean;
  memberDetails?: NormalizedCustomerDto;
  token?: string;
  activeRoute?: ActiveRouteType;
  hasUserLoggedIn?: boolean;
  cookiePermissions?: any;
  version?: string;
  declineFlag?: number;
  previousRoute?: ActiveRouteType;
  chatbotPayload?: TicketEmailAutoResponseDecisionDto;
}

const initialState: AppState = {
  initInProgress: true,
  modalState: {},
  isMobileMenuVisible: false
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setActiveLoanStatus(state, action) {
      state.hasActiveLoan = action.payload;
    },
    toggleMobileMenuVisibility(state, action) {
      state.isMobileMenuVisible = action.payload;
    },
    toggleModalState: {
      reducer: (state, action: PayloadAction<any>) => {
        state.modalState[action.payload.modalId] = action.payload.modalState;
      },
      prepare: (modalId: string, modalState: boolean) => {
        return {
          payload: {
            modalId,
            modalState
          }
        };
      }
    },
    routeEnter(state, action: PayloadAction<ActiveRouteType>) {
      state.activeRoute = action.payload;
    },
    routeExit(state, action: PayloadAction<ActiveRouteType>) {
      state.previousRoute = action.payload;
    },
    authUserLogin(state, action) {
      state.memberDetails = action.payload.memberDetails;
      state.token = action.payload.token;
      state.hasUserLoggedIn = true;
    },
    authUserLogout(state) {
      return {
        ...state,
        memberDetails: undefined,
        token: undefined,
        hasUserLoggedIn: false,
        hasActiveLoan: false
      };
    },
    initStart(state, action: PayloadAction<void>) {
      state.initInProgress = true;
      state.version = __BUILD_VERSION__;
    },
    initFinish(state) {
      state.initInProgress = false;
    },
    applyCookiePermissions(state, action) {
      state.cookiePermissions = action.payload;
    },
    requestSent(state, action) {
      return state;
    },
    responseReceived(state, action) {
      return state;
    },
    routeChanged(state, action) {
      return state;
    },
    setDeclineFlag(state: AppState, action: PayloadAction<number>) {
      state.declineFlag = action.payload;
    },
    setChatbotPayload(state: AppState, action: PayloadAction<TicketEmailAutoResponseDecisionDto>) {
      state.chatbotPayload = action.payload;
    },
    destroy() {
      return initialState;
    }
  }
});

export default appSlice.reducer;
export const {
  setActiveLoanStatus,
  toggleMobileMenuVisibility,
  toggleModalState,
  routeEnter,
  routeExit,
  authUserLogin,
  authUserLogout,
  initStart,
  initFinish,
  applyCookiePermissions,
  requestSent,
  responseReceived,
  routeChanged,
  destroy
} = appSlice.actions;
export const appActions = appSlice.actions;
